import { Fragment } from "react";
import Review from "./Review";

function ReviewList(props) {
  const reviews = props.reviews;

  return (
    <Fragment>
      <h2>Reviews</h2>
      {reviews.length === 0 && (
        <div>
          <p>
            <i>You have not reviewed yet!</i>
          </p>
        </div>
      )}
      {reviews.length > 0 && (
        <div className="reviews" style={{ width: "100%" }}>
          {reviews.map((review) => {
            return (
              <Review
                id={review.id}
                description={review.review_description}
                rate={review.star_number}
                date={review.created_at}
              />
            );
          })}
        </div>
      )}
    </Fragment>
  );
}

export default ReviewList;
